module.exports = __webpack_public_path__ + "static/img/08_click.f3e9b589.png";